module.exports = "<nb-card>\n    <nb-card-header>\n      <h3>Redirigiendo...</h3>\n    </nb-card-header>\n  </nb-card>"